export enum ProjectType {
    FREE_TEXT = "FREE_TEXT",
    CLASSIFIER = "CLASSIFIER"
}

export const resolveNameForProjectType = (type: ProjectType): string => {
    switch (type) {
        case ProjectType.FREE_TEXT:
            return "Free Text"
        case ProjectType.CLASSIFIER:
            return "Classifier"
    }
}

export const resolveDescriptionForProjectType = (type: ProjectType): string => {
    switch (type) {
        case ProjectType.FREE_TEXT:
            return "Generate open-ended text."
        case ProjectType.CLASSIFIER:
            return "Sort inputs into a fixed set of labels."
    }
}
